// RIS order is done when examination status reaches REPORTED
export function isRisOrderCompleted(item) {
  return item?.orderStatus === 'REPORTED';
}

// DycoVue remote reading: done when the radiologist completes the DycoVue report
export function isDycovueReportDone(item) {
  return item?.dycovueReportStatus === 'completed';
}

// Self-report workflow: done when the on-site clinician files a self-report
export function isSelfReportDone(item) {
  return item?.selfReportStatus === 'completed';
}

// Scan Board / Reports List: any report source has been issued.
// Use this ONLY in views that aggregate both DycoVue and self-report workflows
// (i.e. where the domain boundary intentionally spans both reading pathways).
export function isAnyReportDone(item) {
  if (!item) return false;
  return (
    isRisOrderCompleted(item) ||
    isDycovueReportDone(item) ||
    isSelfReportDone(item) ||
    Boolean(item.reportCompleted)
  );
}

/** Study id for report APIs (order rows may use order _id). */
export function getReportStudyRef(item) {
  return {
    ...item,
    _id: item?.pacsStudyId || item?.reportStudyId || item?.studyId || item?._id,
    pacsStudyId: item?.pacsStudyId || item?.reportStudyId || item?.studyId || item?._id,
  };
}
